// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@stoneage/XDL/constants";
import React from "react";
import { css } from "styled-components";

interface LocationContactFieldStyles {
    contactInfoWrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

interface Props {
    label: string;
    href: string;
    value: string;
}

export const locationContactFieldStyles: LocationContactFieldStyles = {
    contactInfoWrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: center;
            font-size: 14px;
            margin-bottom: 8px;
        `,
    },
    link: {
        typographyProps: {
            ...fontConfig.smallSingleLine,
        },
    },
};
const styles = locationContactFieldStyles;

const LocationContactField: React.FC<Props> = ({ label, href, value }) => (
    <StyledWrapper {...styles.contactInfoWrapper}>
        <Typography>{label}:</Typography>
        <Link {...styles.link} href={href} target="_blank">
            {value}
        </Link>
    </StyledWrapper>
);

export default LocationContactField;
